<template>
    <div class="table-wrapper" style="padding-top: 30px">
        <Row :gutter="24">
            <Col span="12">
                <div class="fchart-box">
                    <div class="aFlex fchart-box-top">
                        <span class="ft-bold">工资专户开设比例</span>
                        <!--<span class="ft-gray" style="margin-left: 10px">默认统计系统日期上个月</span>-->
                    </div>
                    <div class="fchart-bi" ref="accountPie">工资专户开设比例</div>
                </div>
            </Col>
            <Col span="12">
                <div class="fchart-box">
                    <div class="aFlex fchart-box-top">
                        <span class="ft-bold">各地银行分布</span>
                    </div>
                    <div class="fchart-bi" ref="accountScatter">各地银行分布</div>
                </div>
            </Col>
        </Row>
        <div class="fchart-box">
            <div class="aFlex fchart-box-top">
                <span class="ft-bold">五大行占比</span>
            </div>
            <div class="fchart-bi" ref="bankPie">五大行占比</div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import {mapState} from 'vuex';
    export default {
        data(){
            return {
                // 账户饼图
                accountPie:null,
                // 账户散点图
                accountScatter:null,
                // 五大行占比
                bankPie:null,
                areaCode: localStorage.getItem('tenantAreaCode')
            };
        },
        computed:{
        },
        watch: {
            areaCode: function () {
                this.getPageData();
            },
        },
        created(){

        },
        mounted(){
            //引入echarts 初始化图标
            let echarts = require('echarts');
            this.accountPie = echarts.init(this.$refs.accountPie);
            this.accountScatter = echarts.init(this.$refs.accountScatter);
            this.bankPie = echarts.init(this.$refs.bankPie);
            //初始化 setOption
            this.initChart();
            //获取数据
            this.getPageData();
            window.addEventListener('resize',this.resize);
            window.addEventListener('load',this.resize);
            /*加载完成自适应*/
            this.$nextTick( ()=> {
                this.resize();
            });
        },
        methods: {
            // echarts 适应
            resize(){
                this.accountPie.resize();
                this.accountScatter.resize();
                this.bankPie.resize();
            },
            initChart(){
                this.accountPie.setOption(
                    {
                        title:{
                            textStyle:{
                                color: '#999999',
                                fontSize:13,
                                fontWeight:400
                            },
                            textAlign:'center',
                            right:'10%',
                            bottom: 15,
                            text: '项目总数',
                        },
                        legend: {
                            orient: 'horizontal',
                            bottom:15,
                            right:'45%',
                            icon:'circle',
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: '{b} : {c} ({d}%)'
                        },
                        color:['#3AA1FF','#36CBCB'],
                        series: [
                            {
                                type: 'pie',
                                center: ['50%', '43%'],
                                radius:['40%', '65%'],
                                label:{
                                    show:true,
                                    formatter:(params)=>{
                                        return `${params.name}: ${params.percent}%`
                                    }
                                },
                                itemStyle: { //图形样式
                                    normal: {
                                        borderColor: '#ffffff',
                                        borderWidth: 2,
                                    },
                                },
                                data:[]
                            }
                        ]
                    }
                );
                this.accountScatter.setOption(
                    {
                        tooltip: {
                            formatter: function (params) {
                                return params.value[0] + ':  ' + params.value[1] + params.value[2]+'个项目';
                            }
                        },
                        grid: {
                            left: 15,
                            top: 30,
                            bottom: 30,
                            right: 40,
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: [],
                            boundaryGap: false,
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    color: '#999',
                                    type: 'dashed'
                                }
                            },
                            axisLine: {
                                show: false
                            },
                            axisTick:{
                                interval:0
                            }
                        },
                        yAxis: {
                            type: 'category',
                            data: [],
                            axisLine: {
                                show: false
                            }
                        },
                        series: [{
                            name: '各地银行分布',
                            type: 'scatter',
                            symbolSize: function (val) {
                                return Math.max(val[2] / 10, 8);
                            },
                            data: [],
                            animationDelay: function (idx) {
                                return idx * 5;
                            }
                        }],
                    }
                );
                this.bankPie.setOption(
                    {
                        tooltip: {
                            trigger: 'item',
                            formatter: '{b} : {c} ({d}%)'
                        },
                        series: [
                            {
                                type: 'pie',
                                center: ['10%', '50%'],
                                radius:['32%', '42%'],
                                label:{
                                    show:false
                                }
                            },
                            {
                                type: 'pie',
                                center: ['30%', '50%'],
                                radius:['32%', '42%'],
                                label:{
                                    show:false
                                }
                            },
                            {
                                type: 'pie',
                                center: ['50%', '50%'],
                                radius:['32%', '42%'],
                                label:{
                                    show:false
                                }
                            },
                            {
                                type: 'pie',
                                center: ['70%', '50%'],
                                radius:['32%', '42%'],
                                label:{
                                    show:false
                                }
                            },
                            {
                                type: 'pie',
                                center: ['90%', '50%'],
                                radius:['32%', '42%'],
                                label:{
                                    show:false
                                }
                            }
                        ]
                    }
                );
            },
            // 工资专用账户统计数据查询
            querySalaryAccount(){
                this.accountPie.showLoading();
                this.accountScatter.showLoading();
                this.bankPie.showLoading();
                this.axios({
                    method: 'post',
                    url: `/summary/querySalaryAccount?areaCode=${this.areaCode || ''}`,
                    data:{
                        areaCode:this.areaCode
                    }
                }).then((response)=> {
                    this.accountPie.hideLoading();
                    this.accountScatter.hideLoading();
                    this.bankPie.hideLoading();
                    if(response.data){
                        this.accountPie.setOption(
                            {
                                title:{
                                    text: '项目总数: '+response.data.pie[2].value+'个',
                                },
                                legend:{
                                    // 使用回调函数
                                    formatter: function (name) {
                                        let val=response.data.pie.filter(item=>{
                                            return item.name===name;
                                        })[0].value || 0;
                                        return name + val;
                                    }
                                },
                                series: [
                                    {
                                        data:response.data.pie.slice(0,-1)
                                    }
                                ]
                            }
                        );
                        let distribution=response.data.distribution;
                        this.accountScatter.setOption(
                            {
                                xAxis: {
                                    data: distribution.x,
                                },
                                yAxis: {
                                    data: distribution.y,
                                },
                                series: [
                                    {
                                        data: distribution.data,
                                    }
                                ],
                                dataZoom : distribution.x.length > 4 ? [
                                    {
                                        startValue : 0,
                                        endValue : 6,
                                        type: 'slider',
                                        show: true,
                                        xAxisIndex: [0],
                                        height: 10,
                                        bottom: 8,
                                        borderRadius: 5,
                                        showDataShadow: false,
                                        showDetail: false,
                                        realtime: true
                                    }
                                ] : [],
                            }
                        );
                    }
                    let colors=['#0096FA','#FEC03D','#52C1F5','#FB6260','#8167F5'];
                    let total = 0;
                    let bankData = response.data.rate;
                    bankData.forEach((item) => {
                        total += Number(item.value);
                    });
                    (total === 0) && (total = 1);
                    let bankPieData = [];
                    for (let i=0;i<bankData.length;i++){
                        bankPieData.push(
                            {
                                data: [
                                    {
                                        name: bankData[i].name,
                                        value: bankData[i].value,
                                        label: {
                                            show: true,
                                            position: 'center',
                                            formatter: '{b}\n{d}%',
                                            color: '#333333',
                                            fontWeight: 400,
                                            fontSize: 15,
                                            lineHeight:25,
                                            align: 'center',
                                        },
                                        itemStyle: {
                                            color: colors[i],
                                        }
                                    },
                                    {
                                        value: total - Number(bankData[i].value),
                                        itemStyle: {
                                            color: '#E9E9E9',
                                        },
                                        hoverAnimation: false,
                                        tooltip: {
                                            show: false
                                        },
                                    },
                                ],
                            }
                        );
                    }
                    this.bankPie.setOption(
                        {
                            series:bankPieData,
                        }
                    );
                });
            },

            /* 获取页面数据 */
            getPageData(){
                this.querySalaryAccount();
            },
        }
    };
</script>
